import { gql } from "@apollo/client";

export const fetchOnSiteDeliveries = gql`
query fetchOnSiteDeliveries($distributionCenterId: [uuid!], $limit: Int, $offset: Int, $search: String) {
    onSiteDeliveries(
      order_by: {created_at: desc},
      where: {
        _and: [
          {user:{userDeliveryCenters:{distributionCenterId: { _in: $distributionCenterId }}}},
          {
            _or: [
              {orderTable: {orderNumber: {_ilike: $search}}},
              {orderTable: {custFullName: {_ilike: $search}}},
              {orderTable: {custIdentificationNumber: {_ilike: $search}}},
              {orderTable: {consecutiveBill: {_ilike: $search}}},
              {orderTable: {consecutiveRemission: {_ilike: $search}}},
              {orderTable: {consecutiveSaleOrder: {_ilike: $search}}},
              {orderTable: {address: {_ilike: $search}}},
              {orderTable: {city: {_ilike: $search}}}
            ]
          }
        ]
      },
      limit: $limit,
      offset: $offset
    ){
      id
      status
      receivedPerson
      receivedDocument
            user {
                displayName
                identificationNumber
                phoneNumber
                userVehicle{
                    id
                }
            }
            orderTable {
                orderNumber
                address
                addressComplement
                custFullName
                custIdentificationNumber
                custPhoneNumber
                paymentMethod
                sectorId
                consecutiveBill
                consecutiveRemission
                consecutiveSaleOrder
                consecutiveBurden
                notes
                consecutiveShipping
                type
                state
                city
                expectedDeliveryStartTime
                expectedDeliveryEndTime
                sector {
                    name
                }
                totalOrderAmount
                weight
                evidences {
                    evidenceType
                    evidenceURL
                    comments
                }
                ordersLines {
                    id
                    productNumber
                    productName
                    orderedQuantity
                    deliveredQuantity
                    initialQuantity
                    summationQuantity
                  }
            }
            orderTableId
            reasonId
            reason {
                description
            }
    }
  }
`;
export const fetchCompletedRoutes = gql`
query fetchCompletedRoutes($distributionCenterId: [uuid!]) {
  routesBatch(order_by: {endDateRoute: desc}, where: {user:{userDeliveryCenters:{distributionCenterId: { _in: $distributionCenterId }}}, _and:{startDateRoute: {_is_null: false}, _and: {endDateRoute: {_is_null: false}}}}) {
      id
      batch
      createdAt
      startDateRoute
      endDateRoute
      user {
          identificationNumber
          displayName
          distributionCenterId
         userDeliveryCenters{
          distributionCenterId
        }
      }
      licencePlate
      routes(order_by: {endDateTime: desc}) {
          id
          status
          startDateTime
          endDateTime
          userId
          distanceText
          distanceValue
          durationText
          durationValue
          receivedPerson
          receivedDocument
          polylines
          user {
              displayName
              identificationNumber
              phoneNumber
              userVehicle{
                  id
              }
          }
          orderTable {
              orderNumber
              address
              addressComplement
              custFullName
              custIdentificationNumber
              custPhoneNumber
              paymentMethod
              sectorId
              consecutiveBill
              consecutiveRemission
              consecutiveSaleOrder
              consecutiveBurden
              consecutiveShipping
              type
              state
              city
              expectedDeliveryStartTime
              expectedDeliveryEndTime
              sector {
                  name
              }
              totalOrderAmount
              weight
              evidences {
                  evidenceType
                  evidenceURL
                  comments
              }
              ordersLines {
                  id
                  productNumber
                  productName
                  orderedQuantity
                  deliveredQuantity
                  initialQuantity
                  summationQuantity
                }
          }
          orderTableId
          reasonId
          reason {
              description
          }
      }
  }
}
`;

export const fetchtelemetry = gql`
query fetchtelemetry($userVehicleId: uuid, $startDateTime: timestamptz, $endDateTime: timestamptz) {
  telemetry(order_by: {timestamp: asc},where: {userVehicleId: { _eq: $userVehicleId },timestamp: {_gte: $startDateTime, _lte: $endDateTime}}) {
    id
    userVehicleId
    latitude
    longitude
    timestamp
    speed
    distance
    userVehicle {
      id
      assignedRoutes {
        id
        startDateTime
        endDateTime
        orderTable{
          id
          orderNumber
        }
      }
    }
  }
}
`;

export const fetchOnSiteDeliveriesCount = gql`
query fetchOnSiteDeliveriesCount($distributionCenterId: [uuid!], $search: String) {
  onSiteDeliveries_aggregate(
    where: {
        _and: [
          {user:{userDeliveryCenters:{distributionCenterId: { _in: $distributionCenterId }}}},
          {
            _or: [
              {orderTable: {orderNumber: {_ilike: $search}}},
              {orderTable: {custFullName: {_ilike: $search}}},
              {orderTable: {custIdentificationNumber: {_ilike: $search}}},
              {orderTable: {consecutiveBill: {_ilike: $search}}},
              {orderTable: {consecutiveRemission: {_ilike: $search}}},
              {orderTable: {consecutiveSaleOrder: {_ilike: $search}}},
              {orderTable: {address: {_ilike: $search}}},
              {orderTable: {city: {_ilike: $search}}}
            ]
          }
        ]
      }
  ) {
    aggregate {
      count
    }
  }
}
`;